import supabase from '../supabaseClient';

/** Ask the server to archive camera footage if needed and start court analysis. Safe to call more than once. */
export function requestCourtAnalysis(matchId) {
  const id = String(matchId || '').trim();
  if (!id) return;
  void supabase.functions.invoke('padelytics-auto', { body: { gameId: id } }).catch(() => {});
}
